import type { ProductVendor } from "@models/product";

// The supply rows that belong to ONE sku (#390): the variant whose id is
// given, or the base, variant-less sku for null. Every consumer of a
// `vendors[]` array narrows through here — the storefront's vendor selection
// and Vendor row, the admin grid's Vendor column and the edit page's vendor
// prefill — so there is one definition of "this sku's rows" to unwind, not
// three.
//
// Every VendorSkuResponse carries `variantId` (#390 — a null Guid serializes
// as null), so a base row is `null` and a variant's row is its id. A row
// without the key is normalised to a BASE row rather than dropped: should the
// API ever serialise with WhenWritingNull, every base-sku row would otherwise
// vanish from the storefront's pricing, the admin grid's Vendor column and the
// edit page's prefill at once. The assumption is not load-bearing this way.
export const vendorRowsForSku = (
    vendors: ProductVendor[] | undefined,
    variantId: string | null,
): ProductVendor[] =>
    (vendors ?? []).filter(
        (vendor) => (vendor.variantId ?? null) === variantId,
    );
